import { motion } from "framer-motion";
import { ArrowDownRight } from "lucide-react";

const BG_URL =
  "https://customer-assets.emergentagent.com/job_dynamic-trust/artifacts/7jyjy39b_fondo-trabajar-juntos.webp";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: "smooth" });
  }
};

export const CtaBanner = () => {
  return (
    <section
      data-testid="cta-banner"
      className="relative py-24 sm:py-32 overflow-hidden"
    >
      {/* Background image */}
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${BG_URL})` }}
      />
      {/* Dark overlay for legibility */}
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-black/55"
      />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          data-testid="cta-banner-headline"
          className="font-display font-bold tracking-tighter leading-[0.95] text-white text-[36px] sm:text-[56px] lg:text-[80px] max-w-5xl mx-auto drop-shadow-[0_4px_30px_rgba(0,0,0,0.45)]"
        >
          ¡VAMOS A HACER{" "}
          <span className="text-[#BF1828]">REALIDAD</span> TUS IDEAS,
          <br />
          VAMOS A TRABAJAR JUNTOS!
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-12"
        >
          <button
            data-testid="cta-banner-button"
            onClick={() => scrollTo("contacto")}
            className="group inline-flex items-center justify-center gap-3 bg-[#BF1828] text-white hover:bg-white hover:text-black transition-all duration-300 px-10 py-5 text-sm uppercase tracking-[0.25em] font-medium"
          >
            Comencemos
            <ArrowDownRight
              size={18}
              className="transition-transform group-hover:translate-x-1 group-hover:translate-y-1"
            />
          </button>
        </motion.div>
      </div>
    </section>
  );
};
